import BaseApiService from '@/services/common/api/baseApiService';

class PrintLabelService extends BaseApiService {
  getPrintLabelData(printLabelId) {
    return this.makeRequest(this.httpClient.get(this.apiEndPointsBuilder.getPrintLabel(printLabelId)));
  }

  addPrintLabel(printLabel) {
    return this.makeRequest(this.httpClient.post(this.apiEndPointsBuilder.addPrintLabel(), { data: printLabel }));
  }
}

export default PrintLabelService;
